import { ElementsProvider } from '../../core/elements';
import { AxisBottom, AxisBottomLine, AxisBottomText, AxisBottomTick } from '../../primitives/axis/axis/AxisBottom';
import { AxisLeft, AxisLeftLine, AxisLeftText, AxisLeftTick } from '../../primitives/axis/axis/AxisLeft';
import { Layout, LayoutContainer } from '../../primitives/container';
import { DimensionsWrapper } from '../../primitives/container/DimensionWrapper';
import { Grid } from '../../primitives/grid/Grid';
import { OrdinalLegend } from '../../primitives/legend';
import { Menu, MenuProvider } from '../../primitives/menu';
import { Theme } from '../../primitives/theme';
import { Subtitle, Title } from '../../primitives/title';
import EventEmitterProvider from '../common/events/context/EventEmitterProvider';
import TooltipProvider from '../common/events/context/TooltipProvider';
import { MultiSeriesTooltip } from '../common/tooltip/MultiSeriesTooltip';
import { AddMark, LineMarkElement, LinePath, PointMarks } from './elements/mark';
import { LineScales } from './elements/scales';
import { LineTooltipOverlayElement } from './elements/tooltip-overlay';
import { PureLineChart } from './pure';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LineChart(_ref) {
  let {
    width,
    height,
    children,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(ElementsProvider, {
    children: /*#__PURE__*/_jsx(TooltipProvider, {
      children: /*#__PURE__*/_jsx(MenuProvider, {
        children: /*#__PURE__*/_jsxs(EventEmitterProvider, {
          children: [children, /*#__PURE__*/_jsx(LayoutContainer, {
            width: width,
            height: height,
            data: restProps.data,
            children: /*#__PURE__*/_jsx(DimensionsWrapper, {
              children: _ref2 => {
                let {
                  margin,
                  plotHeight,
                  plotWidth,
                  plotSvgRef
                } = _ref2;
                return /*#__PURE__*/_jsx(PureLineChart, {
                  svgRef: plotSvgRef,
                  height: plotHeight,
                  width: plotWidth,
                  margin: margin,
                  ...restProps
                });
              }
            })
          })]
        })
      })
    })
  });
}
LineChart.elements = {
  // All of the Axis Left components
  AxisLeft: AxisLeft.Component,
  AxisLeftText: AxisLeftText.Component,
  AxisLeftTick: AxisLeftTick.Component,
  AxisLeftLine: AxisLeftLine.Component,
  // AxisBottomComponents
  AxisBottom: AxisBottom.Component,
  AxisBottomText: AxisBottomText.Component,
  AxisBottomTick: AxisBottomTick.Component,
  AxisBottomLine: AxisBottomLine.Component,
  Layout: Layout.Component,
  Title: Title.Component,
  SubTitle: Subtitle.Component,
  Menu: Menu.Component,
  Theme: Theme.Component,
  Legend: OrdinalLegend.Component,
  Grid: Grid.Component,
  // Linechart custom elements
  Scales: LineScales.Component,
  Tooltip: MultiSeriesTooltip.Component,
  TooltipOverlay: LineTooltipOverlayElement.Component,
  Mark: LinePath.Component,
  Marks: LineMarkElement.Component,
  AddMark: AddMark.Component,
  PointMarks: PointMarks.Component
};